const PARTNER_TOOLS = {
    REPORTING: {
        RESOURCE_ID: 'reporting',
    },
};

export default PARTNER_TOOLS;
